export default "__VITE_ASSET__B7Y3dzzQ__"